import { render, staticRenderFns } from "./CardFechamento.vue?vue&type=template&id=2cd45896&scoped=true&"
import script from "./CardFechamento.vue?vue&type=script&lang=js&"
export * from "./CardFechamento.vue?vue&type=script&lang=js&"
import style0 from "./CardFechamento.vue?vue&type=style&index=0&id=2cd45896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd45896",
  null
  
)

export default component.exports